import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import AvergingPitotTube from 'features/processFlowDiagrams/svg/flow-sensors/averging-pitot-tube.svg?react'
import Coriolis from 'features/processFlowDiagrams/svg/flow-sensors/coriolis.svg?react'
import FlowNozzle from 'features/processFlowDiagrams/svg/flow-sensors/flow-nozzle.svg?react'
import Flume from 'features/processFlowDiagrams/svg/flow-sensors/flume.svg?react'
import Magnetic from 'features/processFlowDiagrams/svg/flow-sensors/magnetic.svg?react'
import PitotTube from 'features/processFlowDiagrams/svg/flow-sensors/pitot-tube.svg?react'
import PositiveDisplacement from 'features/processFlowDiagrams/svg/flow-sensors/positive-displacement.svg?react'
import Rotameter from 'features/processFlowDiagrams/svg/flow-sensors/rotameter.svg?react'
import Target from 'features/processFlowDiagrams/svg/flow-sensors/target.svg?react'
import Turbine from 'features/processFlowDiagrams/svg/flow-sensors/turbine.svg?react'
import Ultrasonic from 'features/processFlowDiagrams/svg/flow-sensors/ultrasonic.svg?react'
import VCone from 'features/processFlowDiagrams/svg/flow-sensors/v-cone.svg?react'
import Venturi from 'features/processFlowDiagrams/svg/flow-sensors/venturi.svg?react'
import Vortex from 'features/processFlowDiagrams/svg/flow-sensors/vortex.svg?react'
import Wedge from 'features/processFlowDiagrams/svg/flow-sensors/wedge.svg?react'
import Weir from 'features/processFlowDiagrams/svg/flow-sensors/weir.svg?react'
import React from 'react'

export const PID_FLOW_SENSORS_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'averging-pitot-tube',
    name: 'Averging Pitot Tube',
    category: 'flow-sensors',
    svgContent: <AvergingPitotTube />,
    viewBox: '0 0 50 50',
  },
  {
    id: 'coriolis',
    name: 'Coriolis',
    category: 'flow-sensors',
    svgContent: <Coriolis />,
    viewBox: '0 0 50 50',
  },
  {
    id: 'flow-nozzle',
    name: 'Flow Nozzle',
    category: 'flow-sensors',
    svgContent: <FlowNozzle />,
    viewBox: '0 0 50 25',
  },
  {
    id: 'flume',
    name: 'Flume',
    category: 'flow-sensors',
    svgContent: <Flume />,
    viewBox: '0 0 50 50',
  },
  {
    id: 'magnetic',
    name: 'Magnetic',
    category: 'flow-sensors',
    svgContent: <Magnetic />,
    viewBox: '0 0 50 50',
  },
  {
    id: 'pitot-tube',
    name: 'Pitot Tube',
    category: 'flow-sensors',
    svgContent: <PitotTube />,
    viewBox: '0 0 50 50',
  },
  {
    id: 'positive-displacement',
    name: 'Positive Displacement',
    category: 'flow-sensors',
    svgContent: <PositiveDisplacement />,
    viewBox: '0 0 50 30',
  },
  {
    id: 'rotameter',
    name: 'Rotameter',
    category: 'flow-sensors',
    svgContent: <Rotameter />,
    viewBox: '0 0 75 50',
  },
  {
    id: 'target',
    name: 'Target',
    category: 'flow-sensors',
    svgContent: <Target />,
    viewBox: '0 0 50 50',
  },
  {
    id: 'turbine',
    name: 'Turbine',
    category: 'flow-sensors',
    svgContent: <Turbine />,
    viewBox: '0 0 50 50',
  },
  {
    id: 'ultrasonic',
    name: 'Ultrasonic',
    category: 'flow-sensors',
    svgContent: <Ultrasonic />,
    viewBox: '0 0 50 50',
  },
  {
    id: 'v-cone',
    name: 'V-cone',
    category: 'flow-sensors',
    svgContent: <VCone />,
    viewBox: '0 0 50 50',
  },
  {
    id: 'venturi',
    name: 'Venturi',
    category: 'flow-sensors',
    svgContent: <Venturi />,
    viewBox: '0 0 50 40',
  },
  {
    id: 'vortex',
    name: 'Vortex',
    category: 'flow-sensors',
    svgContent: <Vortex />,
    viewBox: '0 0 50 50',
  },
  {
    id: 'wedge',
    name: 'Wedge',
    category: 'flow-sensors',
    svgContent: <Wedge />,
    viewBox: '0 0 50 50',
  },
  {
    id: 'weir',
    name: 'Weir',
    category: 'flow-sensors',
    svgContent: <Weir />,
    viewBox: '0 0 50 50',
  },
]
